
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cUDOA", function(module, exports) {

$parcel$export(module.exports, "default", () => $191778eeff36bcc1$export$2e2bcd8739ae039);
/* new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $84Tib = parcelRequire("84Tib");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");

var $6tzHJ = parcelRequire("6tzHJ");

var $4R6GH = parcelRequire("4R6GH");

var $lmBAt = parcelRequire("lmBAt");

var $dCm1o = parcelRequire("dCm1o");

var $3kNE6 = parcelRequire("3kNE6");

var $g503o = parcelRequire("g503o");
const $191778eeff36bcc1$var$ColumnHeader = ({ id: id, menu: menu, title: title, onClick: onClick, isDragging: isDragging, appearance: appearance, isDraggable: isDraggable, isMenuShown: isMenuShown, isMenuEnabled: isMenuEnabled, OverlayContent: OverlayContent, isEditingTitle: isEditingTitle, titleHeadingText: titleHeadingText, isSpinnerVisible: isSpinnerVisible, isMatrixLayout: isMatrixLayout })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    const [isContainerFocused, setIsContainerFocused] = (0, $5uXOq.useState)(false);
    const hasTemporaryId = (0, $5uXOq.useMemo)(()=>Number(id) <= 0, [
        id
    ]);
    const backgroundColor = (0, $5uXOq.useMemo)(()=>$191778eeff36bcc1$var$getBackgroundColor(appearance ?? (0, $3kNE6.ColumnTheme).Default), [
        appearance
    ]);
    const isMenuTriggerShown = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($84Tib)))(isMenuShown) ? isMenuShown : isContainerFocused || isMenuOpen, [
        isMenuShown,
        isContainerFocused,
        isMenuOpen
    ]);
    const canShowMenu = (0, $5uXOq.useMemo)(()=>isMenuEnabled && !hasTemporaryId && !isEditingTitle && !isDragging, [
        isMenuEnabled,
        isEditingTitle,
        isDragging,
        hasTemporaryId
    ]);
    const dynamicBackgroundColorStyleOverride = null;
    const onMenuOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsMenuOpen(attrs.isOpen);
    }, []);
    const renderMenu = (0, $5uXOq.useCallback)(()=>menu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "platform-board-kit.common.ui.column-header.header.meatball",
            className: (0, $bwpsq.default)([
                $191778eeff36bcc1$var$headerStyleMap.menuWrapperBase,
                canShowMenu && $191778eeff36bcc1$var$headerStyleMap.menuWrapperVisibility,
                isMenuTriggerShown && $191778eeff36bcc1$var$headerStyleMap.menuWrapperOpacity,
                "_fkwnaxbu"
            ]),
            style: {
                "--_1ly4823": (0, $lD23V.default)(backgroundColor)
            }
        }, /*#__PURE__*/ (0, $5uXOq.cloneElement)(menu, {
            title: titleHeadingText,
            onOpenChange: onMenuOpenChange
        })) : null, [
        canShowMenu,
        dynamicBackgroundColorStyleOverride,
        isMenuTriggerShown,
        menu,
        onMenuOpenChange,
        titleHeadingText
    ]);
    const onContainerFocus = (0, $5uXOq.useCallback)(()=>{
        if (canShowMenu) setIsContainerFocused(true);
    }, [
        canShowMenu
    ]);
    const onContainerBlur = ()=>{
        setIsContainerFocused(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        onClick: onClick,
        testId: "platform-board-kit.common.ui.column-header.header.column-header-container",
        onFocus: onContainerFocus,
        onBlur: onContainerBlur,
        onMouseEnter: onContainerFocus,
        onMouseLeave: onContainerBlur,
        xcss: (0, $6tzHJ.cx)($191778eeff36bcc1$var$headerStyleMap.columnHeaderContainerBase, isDraggable && $191778eeff36bcc1$var$headerStyleMap.cursorGrab, isMatrixLayout ? $191778eeff36bcc1$var$headerStyleMap.roundedBox : $191778eeff36bcc1$var$headerStyleMap.roundedTopBorder),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            backgroundColor: backgroundColor
        }
    }, OverlayContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OverlayContent, null), (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: [
            (0, $4R6GH.fg)('visual-refresh_drop_6') ? $191778eeff36bcc1$var$ColumnHeaderStyles : $191778eeff36bcc1$var$ColumnHeaderStylesOld
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $191778eeff36bcc1$var$headerStyleMap.titleWrapper
        ])
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            !((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6')) && $191778eeff36bcc1$var$menuWrapperStyles
        ],
        // Prevent menu click to bubble up and fire header analytic event.
        onClick: (event)=>event.stopPropagation()
    }, renderMenu(), isSpinnerVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191778eeff36bcc1$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "small"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191778eeff36bcc1$var$TitleWrapperOld, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191778eeff36bcc1$var$ColumnHeaderActionsOld, {
        // Prevent menu click to bubble up and fire header analytic event.
        onClick: (event)=>event.stopPropagation()
    }, renderMenu(), isSpinnerVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($191778eeff36bcc1$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "small"
    })))));
};
$191778eeff36bcc1$var$ColumnHeader.defaultProps = {
    isDragging: false,
    isDraggable: false,
    isSpinnerVisible: false,
    isMenuEnabled: true,
    isEditingTitle: false
};
var $191778eeff36bcc1$export$2e2bcd8739ae039 = $191778eeff36bcc1$var$ColumnHeader;
const $191778eeff36bcc1$var$getBackgroundColor = (appearance)=>{
    return (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $g503o.columnThemes)[appearance].backgroundNew : (0, $g503o.columnThemes)[appearance].background;
};
const $191778eeff36bcc1$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $191778eeff36bcc1$var$refactoredSpinnerStyle
    }, children);
const $191778eeff36bcc1$var$headerStyleMap = {
    columnHeaderContainerBase: "_v564mfn2 _uiztglyw _1bsb1osq _p12f1osq _vchhusvi _4t3ickbl _kqswh2mm",
    cursorGrab: "_80om1qgj",
    menuWrapperBase: "_3um015vq _tzy4idpf _1bsbidpf",
    menuWrapperVisibility: "_3um0ewfl",
    menuWrapperOpacity: "_tzy4kb7n _1bsb1wug _u5f31b66",
    titleWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _nt751r31 _49pcglyw _1hvw1o36 _7ehi9g9j",
    roundedBox: "_2rkoi2wt _otyru2gc",
    roundedTopBorder: "_13lii2wt _qrwqi2wt"
};
const $191778eeff36bcc1$var$refactoredSpinnerStyle = (0, $2s57o.xcss)({
    paddingRight: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $191778eeff36bcc1$var$ColumnHeaderActionsOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1xi2u2gc _154i1ejb _t9ec1i34",
            __cmplp.className
        ])
    });
});
const $191778eeff36bcc1$var$ColumnHeaderStylesOld = (0, $2s57o.xcss)({
    height: '100%',
    paddingRight: 'space.050'
});
const $191778eeff36bcc1$var$ColumnHeaderStyles = (0, $2s57o.xcss)({
    height: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $191778eeff36bcc1$var$TitleWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1n261q9c _16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _1bah1h6o _4cvr1fhb _1wpz1wug _p12f1osq _ca0qpxbi _u5f3idpf _n3tdpxbi _19bvidpf _1bsb1osq _4t3i1j2a _nt751r31 _49pcglyw _1hvw1o36 _7ehi64oc",
            __cmplp.className
        ])
    });
});
const $191778eeff36bcc1$var$menuWrapperStyles = (0, $2s57o.xcss)({
    flexShrink: 0,
    width: "var(--ds-space-400, 32px)"
});

});


//# sourceMappingURL=new.332430f5.js.map
